<template>
    <bill-shell>
        <section id="more" class="section py-5 bg-white">
            <div class="container ">
                <h1 class="text-8 text-left font-weight-bold mb-4 mt-2">
                    Buy Airtime Online,
                </h1>
                <h3 class="text-6 text-left font-weight-bold mb-4 mt-2">
                    Stay Connected Through Airtime Recharge With Magetsi!
                </h3>
                <p class="text-3">
                    Looking to top up your Econet airtime or purchase NetOne airtime hassle-free? Magetsi has you covered!
                    With our seamless platform, you can conveniently recharge your airtime and stay connected with your loved ones,
                    business partners, or clients. Are you an Econet or NetOne subscriber, Magetsi offers a quick and convenient
                    way to top up your airtime with just a few clicks and multiple options for both individuals and your organization.
                </p>
            </div>
        </section>
        <section class="section py-5 bg-light-4">
            <div class="container">
                <h2 class="text-7 font-weight-bold mb-4 text-left">
                    Top Up Your Econet Airtime in Seconds
                </h2>

                <div class="px-5 text-justify">
                    <p class="text-3 mb-4 mt-3">
                        Running low on Econet airtime? No need to scramble for scratch cards or visit vendors.
                        Here's how to top up your phone instantly and anytime on Magetsi:

                    </p>

                    <ol class="text-3">
                        <li class="py-1">
                            Visit magetsi.co.zw: Head over to our user-friendly website and navigate to the "Mobile Top Up" section.
                        </li>
                        <li  class="py-1">
                            Select Econet as your network option: Clearly identify the network you want to top up.
                        </li>
                        <li  class="py-1">
                            Enter the Phone Number: Accurately input the Econet phone number you want to recharge.
                        </li>
                        <li  class="py-1">
                            Choose the Top-Up Amount: We offer a variety of denominations to suit your needs, so select the amount you wish to add.
                        </li>
                        <li  class="py-1">
                            Choose  Your Payment Method: Magetsi provides secure payment options for your convenience. Choose from EcoCash, VISA, or Mastercard.
                        </li>
                        <li  class="py-1">
                            Complete the Transaction: Follow the on-screen prompts to finalize your payment. Once successful, the recipient's Econet airtime will be topped up instantly.
                        </li>

                    </ol>
                    <h3 class="text-5 font-weight-bold mb-4 text-left">
                        How to Buy NetOne Airtime On Magetsi
                    </h3>
                    <ol class="text-3">
                        <li class="py-1">
                            Visit magetsi.co.zw: Head over to our user-friendly website and navigate to the "Mobile Top Up" section.
                        </li>
                        <li  class="py-1">
                            Select Netone as your network option: Clearly identify the network you want to top up.
                        </li>
                        <li  class="py-1">
                            Enter the Phone Number: Accurately input the Netone phone number you want to recharge.
                        </li>
                        <li  class="py-1">
                            Choose the Top-Up Amount: We offer a variety of denominations to suit your needs, so select the amount you wish to add.
                        </li>
                        <li  class="py-1">
                            Choose  Your Payment Method: Magetsi provides secure payment options for your convenience. Choose from, VISA, or Mastercard.
                        </li>
                        <li  class="py-1">
                            Complete the Transaction: Follow the on-screen prompts to finalize your payment. Once successful, the recipient's Netone airtime will be topped up instantly.
                        </li>

                    </ol>
                    <h3 class="text-5 font-weight-bold mb-4 text-left">
                        The Benefits of Airtime Top-Up with Magetsi.
                    </h3>
                    <p class="text-3 mb-4 mt-3">
                        Magetsi’s online airtime top-up solution was made with people in mind. Let’s delve into why choosing
                        to top-up your Econet and Netone airtime with Magetsi is a plus for you and your loved ones.
                    </p>
                    <ul class="text-3">
                        <li class="py-1">
                            Convenience: Top up any phone from anywhere, anytime, without leaving the comfort of your home and catering to the moments you need airtime urgently.
                        </li>
                        <li  class="py-1">
                            Speed: Transactions are processed instantly, ensuring the recipient receives the airtime immediately.
                        </li>
                        <li  class="py-1">
                            Variety: We offer a wide range of top-up denominations for both Econet and NetOne including bundles.
                        </li>
                        <li  class="py-1">
                            Security: Magetsi utilizes secure payment gateways to protect your financial information.
                        </li>
                    </ul>
                    <p class="text-3 mb-4 mt-3">
                        Make Magetsi your one-stop shop for managing your ZESA tokens and mobile communication needs.
                        Top up your Econet airtime or buy NetOne airtime using your MasterCard today!
                    </p>
                </div>
            </div>
        </section>
        <section class="section mb-0 bg-white">
            <div class="container">
                <h2 class="text-9 font-weight-bold text-center">Frequently Asked Questions</h2>
                <div class="row">
                    <div class="col-md-12 mx-auto">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="accordion accordion-alternate" id="popularTopics">
                                    <div class="card">
                                        <div class="card-header" id="heading1">
                                            <h5 class="mb-0">
                                                <a href="#" class="collapsed" data-toggle="collapse"
                                                   data-target="#collapse1" aria-expanded="false"
                                                   aria-controls="collapse1">
                                                    How to buy airtime for someone in Zimbabwe?
                                                </a>
                                            </h5>
                                        </div>
                                        <div id="collapse1" class="collapse" aria-labelledby="heading1"
                                             data-parent="#popularTopics">
                                            <div class="card-body">
                                                You can use magetsi.co.zw/airtime to send airtime to your loved ones. For a more step-by-step process check How to send airtime to someone in Zimbabwe.
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header" id="heading2">
                                            <h5 class="mb-0"><a href="#" class="collapsed" data-toggle="collapse"
                                                                data-target="#collapse2" aria-expanded="false"
                                                                aria-controls="collapse2">
                                                How long does it take to top up airtime online?
                                            </a>
                                            </h5>
                                        </div>
                                        <div id="collapse2" class="collapse" aria-labelledby="heading2"
                                             data-parent="#popularTopics">
                                            <div class="card-body">
                                                Typically seconds after the payment is completed.
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="accordion accordion-alternate" id="popularTopics2">
                                    <div class="card">
                                        <div class="card-header" id="heading8">
                                            <h5 class="mb-0">
                                                <a href="#" class="collapsed" data-toggle="collapse"
                                                   data-target="#collapse8" aria-expanded="false"
                                                   aria-controls="collapse8">
                                                    Is it safe to buy airtime online?
                                                </a>
                                            </h5>
                                        </div>
                                        <div id="collapse8" class="collapse" aria-labelledby="heading8"
                                             data-parent="#popularTopics2">
                                            <div class="card-body">
                                                Yes, our platform has an end-to-encryption and does not save your card details.
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-header" id="heading6">
                                            <h5 class="mb-0"><a href="#" class="collapsed" data-toggle="collapse"
                                                                data-target="#collapse6" aria-expanded="false"
                                                                aria-controls="collapse6">What happens if I don’t receive my airtime?</a></h5>
                                        </div>
                                        <div id="collapse6" class="collapse" aria-labelledby="heading6"
                                             data-parent="#popularTopics2">
                                            <div class="card-body">
                                                Contact Magetsi Customer Support.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <p class="text-3 mt-5">
                    Make Magetsi your one-stop shop for managing your ZESA tokens and mobile communication needs.
                    Top up your Econet airtime or buy NetOne airtime using your Visa/MasterCard today!
                </p>
            </div>
        </section>
    </bill-shell>
</template>

<script>
import BillShell from "./bill-shell.vue";
import AdScroll from "../core/AdScroll.vue";
export default {
    name: "AirtimeShell",
    components: {BillShell},
    data: () => ({
        providers: ['Econet', 'NetOne', 'Telecel'],
        unavailable: ['Telecel'],
    }),
    computed: {
        provider() {
            return this.$route.query.provider || this.providers[0]
        }
    },
    metaInfo() {
        return {
            title: `Buy ${this.provider} Airtime`,
        }
    }
}
</script>
